module.exports = __webpack_public_path__ + "assets/img/user.adb45185.png";